
import { Model } from 'caldera-immutable-model';

import Collaborator from '../../models/Collaborator';
import CollaboratorCollection from '../../models/CollaboratorCollection';
import CollaboratorInvite from '../../models/CollaboratorInvite';
import CollaboratorInviteCollection from '../../models/CollaboratorInviteCollection';
import TimelineEvent from '../../models/TimelineEvent';
import TimelineEventCollection from '../../models/TimelineEventCollection';

import type { CollaboratorObject, CollaboratorInviteObject } from './types';
import type { Id } from '../types';
import type { TimelineEventObject } from './types';

type CollaboratorInviteCollectionConvertible = CollaboratorInviteObject[] | CollaboratorInvite[] | CollaboratorInviteCollection;
type CollaboratorCollectionConvertible = CollaboratorObject[] | Collaborator[] | CollaboratorCollection;
type TimelineEventCollectionConvertible = TimelineEventObject[]
  | TimelineEvent []
  | TimelineEventCollection;
type ProjectIdConvertible = string;

export default class CollaboratorState extends Model {

  _collaborators: CollaboratorCollection;
  _invites: CollaboratorInviteCollection;
  _events: TimelineEventCollection;

  constructor(data: any) {
    super(data);
    this._invites = new CollaboratorInviteCollection(this.get('invites'));
    this._collaborators = new CollaboratorCollection(this.get('collaborators'));
    this._events = new TimelineEventCollection(this.get('events'));
  }

  get collaborators(): CollaboratorCollection {
    return this._collaborators;
  }

  setCollaborators(collaborators: CollaboratorCollectionConvertible): CollaboratorState {
    return this.set('collaborators', collaborators);
  }

  get isFetchingCollaborators(): boolean {
    return !!this.get('isFetchingCollaborators');
  }

  setIsFetchingCollaborators(isFetching: boolean): CollaboratorState {
    return this.set('setIsFetchingCollaborators', isFetching);
  }

  get isCreatingCollaborator(): boolean {
    return !!this.get('isCreatingCollaborator');
  }

  setIsCreatingCollaborator(isCreating: boolean): CollaboratorState {
    return this.set('isCreatingCollaborator', isCreating);
  }

  // Invites

  get invites(): CollaboratorInviteCollection {
    return this._invites;
  }

  setInvites(invites: CollaboratorInviteCollectionConvertible): CollaboratorState {
    return this.set('invites', invites);
  }

  get isFetchingInvites(): boolean {
    return !!this.get('isFetchingInvites');
  }

  setIsFetchingInvites(isFetching: boolean): CollaboratorState {
    return this.set('isFetchingInvites', isFetching);
  }

  removeInviteById(id: Id): CollaboratorState {
    // $FlowFixMe
    return this.setInvites(this.invites.removeById(id));
  }

  // Getting and Creating Project and Events

  get isCreatingProject(): boolean {
    return !!this.get('isCreatingProject');
  }

  setIsCreatingProject(isCreating: boolean): CollaboratorState {
    return this.set('isCreatingProject', isCreating);
  }

  get events(): TimelineEventCollection {
    return this._events;
  }

  setEvents(events: ?TimelineEventCollectionConvertible): CollaboratorState {
    return this.set('events', events);
  }

  get isCreatingEvent(): boolean {
    return !!this.get('isCreatingEvent');
  }

  setIsCreatingEvent(isCreating: boolean): CollaboratorState {
    return this.set('isCreatingEvent', isCreating);
  }

  setProjectId(projectId: string): CollaboratorState {
    return this.set('projectId', projectId);
  }
}


// WEBPACK FOOTER //
// ./src/redux/collaborators/CollaboratorState.js